// ~/Flow/Nodes/TurboNode.tsx

'use client';

import React, { ReactNode } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import Image from 'next/image';

import { Pencil2Icon } from '@radix-ui/react-icons';
import { FiCloud } from 'react-icons/fi';

import { useFlowContext } from '#/providers/FlowContext';
import { ActionNodeData, TriggerNodeData } from '#/types/workspace';
import { parseCronString } from '#/utils/parseCronString';

import ContextMenu from '~/ui/context-menu';

// TODO

// export type FlowNodeType = {
//   id: string;
//   title: string;
//   description: string;
//   trigger?: NodeTrigger;
//   action?: NodeActon;
//   icons?: ReactNode;
//   subline?: string;
// };

// export type NodeTrigger = {
//   default: IO;
//   mock: NA;
//   custom: NA;
//   manual: NA;
//   cron: NA;
//   webhook: NA;
//   event: NA;
//   schedule: NA;
//   api: NA;
//   email: NA;
//   sms: NA;
//   slack: NA;
//   telegram: NA;
//   discord: NA;
//   push: NA;
//   facebook: NA;
//   twitter: NA;
//   socket: Na;
//   condition: boolean;
// };
// export type NodeActon = {};

// export type DefaultNodeData = {
//   id: string;
//   title: string;
//   type: FlowNodeType;
//   description: string;
//   trigger?: NodeTrigger;
//   action?: NodeActon;
//   icons?: [icon: [IconType]];
//   subline?: string;
// };

export interface TurboNodeData {
  title: string;
  icon?: ReactNode;
  subline?: string;
  serviceType?: string;
  actionType?: string;
  isLateral?: boolean;
}

function NodeBody(props: {
  nodeProps: any;
  nodeData: any;
  // updateNodeData: any;

  icons?: string[];
  title?: string;
  subline?: string;
  detail?: string;
}) {
  const {
    nodeProps,
    nodeData,
    /*updateNodeData,*/ icons,
    title,
    subline,
    detail,
  } = props;

  const {
    setCanDeleteNode,
    setSelectedNodeProps,
    setSelectedNodeData,
    // setUpdateSelectedNodeData,
    setIsNodeDetailsShown,
  } = useFlowContext();

  function handleEditClick() {
    setSelectedNodeProps(nodeProps);
    setSelectedNodeData(nodeData);
    // setUpdateSelectedNodeData(updateNodeData);
    setCanDeleteNode(false);
    setIsNodeDetailsShown(true);
  }

  return (
    <div className="wrapper gradient min-w-[160px] min-h-[90px]">
      <div className="inner">
        <div className="body flex flex-col justify-center items-start">
          <div className="flex flex-row justify-between items-center space-x-2">
            {/* {icons && icons.length > 0 ? (
              <div className="icons">
                {icons.map((cl) => (
                  <DynamicIcon className={`${cl}`} />
                ))}
              </div>
            ) : null} */}
            <div className="title">{title}</div>
            <button onClick={handleEditClick} className="top-[-2px]">
              <Pencil2Icon className="top-[-2px]" />
            </button>
          </div>
          <div>{subline ? <div className="subline">{subline}</div> : null}</div>
          <div>{detail ? <div className="subline">{detail}</div> : null}</div>
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Top}
        style={{ border: '1px solid black' }}
      />
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

export function TurboNode(
  props: NodeProps<TurboNodeData & (ActionNodeData | TriggerNodeData)>,
) {
  // const { userSession, user } = useUserContext();
  // const userAddress = userSession?.address;

  // const { workspace: workspaceUuid } = useParams();

  // const { setNodes } = useReactFlow();

  // console.debug('[TurboNode] props:', props);
  const { id: nodeId, xPos, yPos, type: nodeType, data: nodeData } = props;

  // const [nodeData, setNodeData] = useState(data);
  // console.debug('[TurboNode] nodeData:', nodeData);
  const {
    uuid: nodeUuid,
    type: nodeDataType,
    logoUrl,
    icons,
    title,
    subline,
  } = nodeData;

  enum WorkflowOrientation {
    'VERTICAL' = 'VERTICAL',
    'LATERAL' = 'LATERAL',
  }
  const DEFAULT_WORKFLOW_ORIENTATION = WorkflowOrientation.VERTICAL;
  const isLateral =
    nodeData?.isLateral ??
    DEFAULT_WORKFLOW_ORIENTATION === WorkflowOrientation.LATERAL;

  const triggerType = nodeDataType !== 'trigger' ? null : nodeData?.triggerType;

  const detail =
    nodeDataType === 'trigger' &&
    triggerType === 'cron' &&
    nodeData?.inputValues?.schedule
      ? parseCronString(nodeData?.inputValues?.schedule)
      : undefined;

  // async function updateNodeData(updatedNodeData: Partial<INodeData>) {
  //   try {
  //     // TODO: schema validation
  //     // ...

  //     console.debug(
  //       '[TurboNode] updateNodeData({ updatedNodeData:',
  //       JSON.stringify({ ...updatedNodeData }),
  //       '});',
  //     );
  //     const nodeUuid = nodeData?.uuid;
  //     const oldNodeData = nodeData;
  //     console.debug('oldNodeData:', JSON.stringify(oldNodeData));

  //     const newNodeDataType = updatedNodeData?.type ?? oldNodeData?.type;

  //     let newNode;
  //     let newNodeData;

  //     if (newNodeDataType === 'trigger') {
  //       newNode = createTriggerNode({
  //         ...props,
  //         id: nodeId,
  //         position: { x: xPos, y: yPos },
  //         type: nodeType,
  //         data: { uuid: nodeUuid, triggerType: 'cron', ...updatedNodeData },
  //       });
  //       newNodeData = newNode.data;
  //     } else {
  //       newNode = await createActionNode({
  //         ...props,
  //         id: nodeId,
  //         position: { x: xPos, y: yPos },
  //         type: nodeType,
  //         data: { ...oldNodeData, ...updatedNodeData },
  //       });
  //       newNodeData = newNode.data;
  //     }

  //     console.debug('[TurboNode] newNode:', JSON.stringify(newNode));
  //     console.debug('[TurboNode] newNodeData:', JSON.stringify(newNodeData));

  //     const updateWorkspaceNodeResult = await updateWorkspaceNode({
  //       ownerAddress: userAddress!,
  //       workspaceUuid,
  //       updatedWorkspaceNode: newNode,
  //     });
  //     console.debug(
  //       '[TurboNode] updateWorkspaceNodeResult:',
  //       updateWorkspaceNodeResult,
  //     );

  //     // Update ReactFlow State
  //     setNodes((nodes) =>
  //       nodes.map((n) => (n?.data?.uuid === nodeUuid ? newNode : n)),
  //     );

  //     // Update Local Component State
  //     setNodeData(newNodeData);

  //     toast.success('Save was successful!');
  //   } catch (error: any) {
  //     console.error(error);
  //     toast.error(`Save failed! Error: ${error.message}`, {
  //       autoClose: false,
  //       closeOnClick: false,
  //       draggable: false,
  //     });
  //   }
  // }

  return (
    <div className="relative">
      <ContextMenu>
        <div className="corner-icon cloud gradient">
          <div>
            {logoUrl ? (
              <Image
                className="rounded-full"
                height={24}
                width={24}
                src={logoUrl}
                alt={title}
              />
            ) : (
              <FiCloud />
            )}
          </div>
        </div>
        <NodeBody
          {...{
            nodeProps: props,
            nodeData,
            // updateNodeData,

            icons,
            title,
            subline,
            detail,
          }}
        />
      </ContextMenu>
    </div>
  );

  // return (
  //   <>
  //     <DropdownMenu.Root>
  //       <DropdownMenu.Trigger
  //         asChild
  //         // onClick={getServiceActions}
  //       >
  //         <div className="cloud gradient">
  //           <div>{<CornerIcon />}</div>
  //         </div>
  //       </DropdownMenu.Trigger>
  //       <DropdownMenu.Portal>
  //         <DropdownMenu.Content
  //           className="DropdownMenuContent text-blue-500 bg-black  border-green-300"
  //           sideOffset={5}
  //         >
  //           <DropdownMenu.Item
  //             className="DropdownMenuItem hover:cursor-pointer"
  //             // onSelect={() => handleServiceSelect('zapier')}
  //           >
  //             Zapier
  //           </DropdownMenu.Item>
  //           <DropdownMenu.Item
  //             className="DropdownMenuItem hover:cursor-pointer"
  //             // onSelect={() => handleServiceSelect('twitter')}
  //           >
  //             Twitter
  //           </DropdownMenu.Item>

  //           <DropdownMenu.Arrow className="DropdownMenuArrow" />
  //         </DropdownMenu.Content>
  //       </DropdownMenu.Portal>
  //     </DropdownMenu.Root>

  //     <div className="wrapper gradient">
  //       <DropdownMenu.Root>
  //         <div className="inner">
  //           <div className="body">
  //             <DropdownMenu.Trigger asChild>
  //               {data.icon && (
  //                 <div className="icon">
  //                   {(data.icon === typeof IconBase && data.icon !== null) ||
  //                   undefined ? (
  //                     data.icon
  //                   ) : (
  //                     <FiCloud />
  //                   )}
  //                 </div>
  //               )}
  //             </DropdownMenu.Trigger>
  //             <DropdownMenu.Portal className=" border-blue-300">
  //               <DropdownMenu.Content
  //                 className="DropdownMenuContent text-blue-500 bg-black  border-green-300"
  //                 sideOffset={5}
  //               >
  //                 {/* {getServiceActions().map((action, index) => (
  //                   <DropdownMenu.Item
  //                     key={index}
  //                     className="DropdownMenuItem hover:cursor-pointer"
  //                     onSelect={() => handleActionSelect(action)}
  //                   >
  //                     {action}
  //                   </DropdownMenu.Item>
  //                 ))} */}
  //               </DropdownMenu.Content>
  //             </DropdownMenu.Portal>
  //             <div>
  //               {data.title ? <div className="title">{data.title}</div> : null}
  //               {data.subline ? (
  //                 <div className="subline">{data.subline}</div>
  //               ) : null}

  //               {/* <div className="flex row space-x-8">
  //                 <NodeForm
  //                   isLateral={isLateral}
  //                   schema={inputSchema}
  //                   onChange={onInputsChange}
  //                 />
  //                 <NodeForm
  //                   isLateral={isLateral}
  //                   schema={outputSchema}
  //                   onChange={onOutputsChange}
  //                 />
  //               </div> */}
  //             </div>
  //           </div>
  //           <Handle
  //             type="target"
  //             position={isLateral ? Position.Left : Position.Top}
  //           />
  //           <Handle
  //             type="source"
  //             position={isLateral ? Position.Right : Position.Bottom}
  //           />
  //         </div>
  //       </DropdownMenu.Root>
  //     </div>
  //   </>
  // );
}

export default TurboNode;

export const nodeTypes = {
  turbo: TurboNode,
};
